export default {
    name: 'Проект',
    back: 'Назад',
    sample: 'Пример кнопки',
};
